module.exports = __webpack_public_path__ + "static/img/title-2.56477330.svg";